import _ from 'lodash'
import { Vue, Component, Inject, Prop, Watch } from 'vue-property-decorator'
import { IOption, IGroup } from '@/components/form/FieldTypes'
import RuleHelper from '@/utils/RuleHelper'
import { Getter } from 'vuex-class'

export interface EventInput {
  target: HTMLInputElement
}

@Component
export default class BaseInput extends Vue {
  @Inject('formName') public formName!: string
  @Prop(String) protected className!: string
  @Prop(String) protected title!: string
  @Prop(String) protected label!: string
  @Prop(String) protected name!: string
  @Prop(Array) protected rules!: any[]
  @Prop(String) protected placeholder!: string
  @Prop(String) protected parent!: string
  @Prop(String) protected type!: string
  @Prop(Number) protected height!: number
  @Prop(Number) protected width!: number
  @Prop(String) protected prefix!: string
  @Prop(String) protected suffix!: string
  @Prop(String) protected maxlength!: string
  @Prop(Boolean) protected dense!: boolean
  @Prop(Boolean) protected rounded!: boolean
  @Prop(Boolean) protected filled!: boolean
  @Prop(Boolean) protected solo!: boolean
  @Prop(Boolean) protected loading!: boolean
  @Prop() protected value!: any
  @Prop(Array) protected options!: IOption[] | IGroup[] | any[]
  @Prop(String) protected icon!: string
  @Prop(Function) protected allowDate!: any
  @Prop(String) protected end!: string
  @Prop(Boolean) protected disabled!: boolean
  @Prop(Boolean) protected readonly!: boolean
  @Prop(Boolean) protected multiple!: boolean
  @Prop(String) protected hint!: string
  @Prop(Boolean) protected persistentHint!: boolean
  @Prop(Boolean) protected hideDetail!: boolean
  @Prop(Boolean) protected returnObject!: boolean
  @Prop(Boolean) protected validateOnBlur!: boolean
  @Prop(Object) protected direction!: { row?: boolean, column?: boolean } // radio
  @Prop() protected defaultValue!: any
  @Prop(Function) protected transform?: (value: any, oldValue: any) => any
  @Prop({default: false}) protected isHide!: boolean
  @Prop({default: false}) protected isHideDetail!: boolean
  @Prop({default: false}) protected isAction!: boolean
  @Prop({default: null}) protected min!: string
  @Prop({default: null}) protected max!: string
  @Prop({default: () => ({})}) protected form!: any

  protected innerValue: any = null

  @Getter('form/getByName')
  private getByName!: (name: string) => any

  get isRequired(): boolean {
    return this.rules ? this.rules.find((r) => r === RuleHelper.required) : false
  }

  public created() {
    this.init()
  }

  public init() {
    const value = this.value
    if (!_.isUndefined(value) && _.isUndefined(this.defaultValue)) {
      this.innerValue = value
    } else {
      this.innerValue = _.isUndefined(this.defaultValue) ? null : this.defaultValue
    }
  }

  public onInput(value: any) {
    this.$emit('change', value, this.name)
    this.innerValue = this.transform ? this.transform(value, this.innerValue) : value || null
  }

  public doFilterOption(lists: any, key: string, parent: any) {
    return _.filter(lists, { [key]: parent })
  }

  @Watch('innerValue', {deep: true})
  public onChange(value: any, oldValue: any) {
    if (!_.isEqual(value, oldValue)) {
      const newRawValue = _.isUndefined(value) ? null : value
      this.$store.dispatch(
        'form/updateAttr',
        {
          formName: this.formName,
          attrName: this.name,
          value: newRawValue,
        })
      this.$emit('input', newRawValue, this.name)
    }
  }

  @Watch('value', {deep: true})
  public onValueChange(value: any, oldValue: any) {
    if (!_.isEqual(value, oldValue)) {
      this.innerValue = value
    }
  }

  @Watch('defaultValue', {deep: true})
  public onDefaultValueChange(value: any, oldValue: any) {
    if (!_.isEqual(value, oldValue)) {
      this.innerValue = this.defaultValue
    }
  }
}
